import { MaintenanceTaskInterface } from "module/maintenanceTask/types";

export const isSerializedArticleAvailable = (
  maintenanceTask: MaintenanceTaskInterface
): boolean =>
  Boolean(
    maintenanceTask.definition &&
      maintenanceTask.definition.serializedArticleId != null
  );
